(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-techincal-icons"]) return;
  try {
    
    jQuery('.rating-readmore').click(function(e) {
        if (e) {
            e.preventDefault();
        }

        jQuery('.rating-readmore').not(this).parents('.item.active').eq(0).removeClass('active').find('.text-field').slideUp();
        if(!jQuery(this).parents('.item').eq(0).hasClass('active')){
            jQuery(this).parents('.item').eq(0).addClass('active').find('.text-field').slideDown();
        } else {
            jQuery(this).parents('.item').eq(0).removeClass('active').find('.text-field').slideUp();
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-icons"]) return;
  try {
    
    jQuery('.rating-readmore').click(function(e) {
        if (e) {
            e.preventDefault();
        }

        jQuery('.rating-readmore').not(this).parents('.item.active').eq(0).removeClass('active').find('.text-field').slideUp();
        if(!jQuery(this).parents('.item').eq(0).hasClass('active')){
            jQuery(this).parents('.item').eq(0).addClass('active').find('.text-field').slideDown();
        } else {
            jQuery(this).parents('.item').eq(0).removeClass('active').find('.text-field').slideUp();
        }
    });

  } catch(e) { console.error(e); }
})();
})();
